<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 15:15:25
 * @LastEditTime: 2025-03-11 10:01:30
-->
<template>
    <div class="sup-search-bar-comp">
        <div class="search-input-box">
            <el-input
                class="search-input"
                prefix-icon="Search"
                v-model:modelValue="search_input"
                placeholder="请输入关键词"
                @keyup.enter="search_click"></el-input>
            <div class="search-btn" @click="search_click">搜索</div>
        </div>
        <div class="search-tag-box">
            <span class="search-tag-tip">高频搜索词</span>
            <div class="search-tag-item" v-for="(item, index) in search_hot_tag_list_computed" :key="index" @click="search_tag_click(item)">
                <span>{{ item }}</span>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, getCurrentInstance, onMounted, computed } from 'vue';
import { useSearchStore } from '@/stores/search';

const search_store = useSearchStore();

const props = defineProps({
    search_keywords: String,
    search_bar_callback: Function,
});

const { proxy } = getCurrentInstance();
const search_input = ref('');

const search_hot_tag_list_computed = computed(() => {
    let search_hot_keywords = search_store.getSortedSearches();
    let hot_tag_list = search_hot_keywords.slice(0, 6).map((item) => item.keyword);
    return hot_tag_list;
});

onMounted(() => {
    search_input.value = props.search_keywords;
});

// MARK Click  搜索点击
const search_click = () => {
    if (!search_input.value || /^\s*$/.test(search_input.value)) {
        //^ 表示匹配字符串的开始位置, \s* 表示匹配零个或多个空白字符（包括空格、制表符、换页符等）, $ 表示匹配字符串的结束位置。
        proxy.$message.warning('请输入搜索内容！');
        return;
    }
    props.search_bar_callback(search_input.value);
};
// MARK Click  高频搜索词点击
const search_tag_click = (item) => {
    search_input.value = item;
    search_click();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-search-bar-comp {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 108px;
    flex-shrink: 0;
    align-items: center;

    :deep(.search-input-box) {
        position: relative;
        width: 860px;
        height: 48px;
        flex-shrink: 0;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--color-main-light-bg-white);
        padding-left: 20px;
        box-sizing: border-box;
        overflow: hidden;

        .search-input .el-input__wrapper {
            box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
            color: var(--color-main-text-search);
            font-size: 16px;
        }

        .search-btn {
            position: relative;
            width: 106px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--color-main-brand);
            color: var(--color-main-text-brand-bg-primary);
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
        }
    }

    .search-tag-box {
        position: relative;
        margin-top: 25px;
        max-width: 1000px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        .search-tag-tip {
            position: relative;
            margin-right: 20px;
            font-size: 18px;
            font-weight: 400;
            width: 100px;
            height: 24px;
            line-height: 24px;
            flex-shrink: 0;
            color: var(--color-main-text-dark-bg-primary);
        }

        .search-tag-item {
            position: relative;
            margin-right: 8px;
            min-width: 68px;
            max-width: 130px;
            height: 100%;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            padding: 8px 20px;
            box-sizing: border-box;

            &:hover {
                background-color: var(--color-main-dev-center-switch-item-bg);
            }

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 14px;
                font-weight: 400;
                color: var(--color-main-text-dark-bg-primary);
            }
        }
    }
}
</style>
